<template>
    <div class="overlay-body">
        <slot />
    </div>
</template>

<script>
export default {

    name: 'OverlayBody'

};
</script>
